import { __extends, __generator, __values } from "tslib";
import { action, makeObservable, reaction } from 'mobx';
import { FormAbstractGroup } from './form-abstract-group';
import { ControlTypes } from './сontrol-types';
var FormGroup = /** @class */ (function (_super) {
    __extends(FormGroup, _super);
    function FormGroup(
    /**
     * Сontrols
     * / Контролы
     */
    controls, 
    /**
     * Options
     * / Опции
     */
    options) {
        var e_1, _a;
        if (options === void 0) { options = {}; }
        var _b, _c;
        var _this = _super.call(this, (_b = options.activate) !== null && _b !== void 0 ? _b : null, options.additionalData, ControlTypes.Group) || this;
        Object.defineProperty(_this, "reactionOnIsActiveDisposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "validators", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(_this, "controls", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "dispose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var e_2, _a;
                _super.prototype.dispose.call(_this);
                _this.reactionOnIsActiveDisposer();
                try {
                    for (var _b = __values(_this.getControls()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var control = _c.value;
                        control.dispose();
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        });
        Object.defineProperty(_this, "executeAsyncValidation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (validator) {
                return _this.baseExecuteAsyncValidation(validator, function () { return _this.checkGroupValidations(); });
            }
        });
        Object.defineProperty(_this, "checkGroupValidations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.inProcessing = true;
                _this.serverErrors = [];
                _this.onValidation(_this.validators, _this.checkGroupValidations, function () { return _this.inProcessing = false; });
            }
        });
        makeObservable(_this, {
            checkGroupValidations: action
        });
        _this.controls = controls;
        _this.validators = (_c = options.validators) !== null && _c !== void 0 ? _c : [];
        _this.reactionOnIsActiveDisposer = reaction(function () { return _this.active; }, function () {
            _this.serverErrors = [];
            _this.checkGroupValidations();
            _this.onChange.call(_this);
        });
        try {
            for (var _d = __values(_this.getControls()), _e = _d.next(); !_e.done; _e = _d.next()) {
                var control = _e.value;
                control.onChange.addListen(function () {
                    _this.serverErrors = [];
                    _this.checkGroupValidations();
                    _this.onChange.call(_this);
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        _this.checkGroupValidations();
        return _this;
    }
    Object.defineProperty(FormGroup.prototype, "getControls", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b, _i, keyName;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = [];
                        for (_b in this.controls)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        keyName = _a[_i];
                        return [4 /*yield*/, this.controls[keyName]];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        }
    });
    Object.defineProperty(FormGroup.prototype, "runInAction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (action) {
            var _this = this;
            this.reactionOnValidatorDisposers.push(reaction(function () { return action(); }, function () { return _this.checkGroupValidations(); }));
        }
    });
    ;
    return FormGroup;
}(FormAbstractGroup));
export { FormGroup };
//# sourceMappingURL=form-group.js.map